export default __webpack_public_path__ + "static/Taiwan-da2b1fff9f3028848cad9e1a252b0e6d.png";